import React from 'react'

export const storyTourConfig = (t) => ({
    id: 'story-generation',
    name: t('tour:story_generation_name'),
    description: t('tour:story_generation_desc'),
    icon: 'book',
    steps: [
        {
            target: '[data-tour="expand-icon"]',
            title: t('tour:story_generation_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_0_content')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="story"]',
            title: t('tour:story_generation_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_1_content_prefix')} <strong>{t('tour:story_generation_step_1_content_bold')}</strong> {t('tour:story_generation_step_1_content_suffix')}</p>
                </div>
            ),
            placement: 'right',
            disableNextInitially: true
        },
        {
            target: '[data-tour="page-preview"]',
            title: t('tour:story_generation_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_2_content')}</p>
                </div>
            ),
            placement: 'left',
            disableNextInitially: true
        },
        {
            target: '[data-tour="create-content-button"]',
            title: t('tour:story_generation_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_3_content_prefix')} <strong>{t('tour:story_generation_step_3_content_bold')}</strong> {t('tour:story_generation_step_3_content_suffix')}</p>
                </div>
            ),
            placement: 'top',
            disableNextInitially: true
        },
        {
            target: '.story-creation-modal',
            title: t('tour:story_generation_step_4_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_4_content')}</p>
                </div>
            ),
            placement: 'center',
            waitFor: '.story-creation-modal'
        },
        {
            target: '[data-tour="generate-story-btn"]',
            title: t('tour:story_generation_step_5_title'),
            content: (
                <div>
                    <p>{t('tour:story_generation_step_5_content_prefix')} <strong>{t('tour:story_generation_step_5_content_bold')}</strong> {t('tour:story_generation_step_5_content_suffix')}</p>
                </div>
            ),
            placement: 'top'
        }
    ]
})
